import React, { Component } from 'react';
import ReactTable from 'react-table';
import { Link } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getUsers } from '../api/user';
import Content from '../components/layout/Content';
import '../table.css';
import Loading from '../components/Loading';

class UserList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      users: [],
    };
  }

  async componentDidMount() {
    const { user } = this.props;
    // const masterUserId = user.isAdmin ? user.id : user.masterUser;
    const masterUser = user && (user.masterUserId || user.id);
    const res = await getUsers(masterUser);
    this.setState({ users: res.data.users });
  }


  render() {
    const { users } = this.state;
    const { intl } = this.props;
    return (
      <Content title={intl.formatMessage({ id: 'userList.title' })}>
        {
          !users ? <Loading />
            : (
              <ReactTable
                data={users}
                columns={[
                  {
                    columns: [
                      {
                        Header: intl.formatMessage({ id: 'userList.name' }),
                        accessor: 'name',
                      },
                      {
                        Header: intl.formatMessage({ id: 'userList.email' }),
                        accessor: 'email',
                      },
                      {
                        Header: intl.formatMessage({ id: 'userList.actions' }),
                        id: 'id',
                        accessor: (d) => <Link to={`/panel/user/${d.id}`}>{intl.formatMessage({ id: 'userList.detail' })}</Link>,
                        maxWidth: 150,
                      },
                    ],
                  },
                ]}
                defaultPageSize={10}
                className="table"
              />
            )
        }
      </Content>
    );
  }
}
UserList.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  user: PropTypes.shape({
    isAdmin: PropTypes.number,
    id: PropTypes.number,
    masterUser: PropTypes.oneOf([PropTypes.number, null]),
  }).isRequired,
};
const mapStateToProps = (state) => ({ user: state.auth.user });
export default injectIntl(connect(mapStateToProps)(UserList));
